import merge from 'lodash/merge'
import { ChartCandle, HollowCandleSeriesOptions } from '../chart.typings'
import BaseChartSeries from './baseSeries'
import { hollowCandleSeriesOptions } from '../../../assets/constants'
import { DeepPartial } from 'lightweight-charts'
import { deepClone } from '@mui/x-data-grid/utils/utils'

class HollowCandleSeries extends BaseChartSeries<ChartCandle, HollowCandleSeriesOptions> {
    addSeriesToChart() {
        return this.chart.chartApi.addCandlestickSeries(this.seriesOptions)
    }

    getDefaultOptions(): HollowCandleSeriesOptions {
        return merge(hollowCandleSeriesOptions, this.options)
    }

    onOptionsUpdate(options: DeepPartial<HollowCandleSeriesOptions>): void {
        this._setData(this.rawData)
    }

    generateSeriesData(data: ChartCandle[], metadata: Record<string, any> = {}): ChartCandle[] {
        const upColor = this.seriesOptions.upColorHollow || '#26a69a'
        const downColor = this.seriesOptions.downColorHollow || '#ef5350'
        const borderUpColor = this.seriesOptions.borderUpColorHollow || upColor
        const borderDownColor = this.seriesOptions.borderDownColorHollow || downColor
        const wickUpColor = this.seriesOptions.wickUpColorHollow || upColor
        const wickDownColor = this.seriesOptions.wickDownColorHollow || downColor
        const borderVisibleHollow = this.seriesOptions.borderVisibleHollow
        const wickVisibleHollow = this.seriesOptions.wickVisibleHollow

        return (deepClone(data) as ChartCandle[]).map((candle, index) => {
            const isHollow = candle.close > candle.open
            const prevClose = index > 0 ? data[index - 1].close : candle.close

            const trendColor = candle.close > prevClose ? upColor : downColor
            const wickColorFinal = wickVisibleHollow === false ? 'transparent' : candle.close > prevClose ? wickUpColor : wickDownColor

            const borderColorFinal = isHollow
                ? trendColor // always visible for hollow
                : borderVisibleHollow === false
                  ? 'transparent' // hide if toggle is off
                  : candle.close > prevClose
                    ? borderUpColor
                    : borderDownColor

            return {
                ...candle,
                color: isHollow ? 'transparent' : trendColor,
                borderColor: borderColorFinal,
                wickColor: wickColorFinal,
                isHollow
            }
        })
    }
}

export default HollowCandleSeries
